var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asset)?_c('img',{attrs:{"src":_vm.asset,"alt":_vm.brand,"height":_vm.height}}):_c('v-icon',{attrs:{"size":Number(_vm.height),"color":"secondary","title":_vm.title}},[_vm._v("mdi-credit-card-outline")])}
var staticRenderFns = []

export { render, staticRenderFns }